/* eslint-disable */
export default {
  showDevScreens: __DEV__, // __DEV__,  this shows the button with all the demo stuff
  useFixtures: false,
  ezLogin: false,
  yellowBox: __DEV__,
  reduxLogging: __DEV__,
  includeExamples: __DEV__,
  useReactotron: __DEV__,
}
